<template>
  <div>
    <b-card-body>
      <b-card class="importContainer">
        <b-form-group>
          <div class="table-container">
            <table class="definir-metas-table">
              <thead>
                <tr>
                  <th>Indicador</th>
                  <th>Meta</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in localMetaItems" :key="idx">
                  <td>{{ item.variable }}</td>
                  <td>
                    <b-form-input
                      v-model="item.metaValue"
                      type="text"
                      @input="(value) => handleNumberInput(value, item)"
                      placeholder="Digite o valor"
                      class="manual-input"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-form-group>
        <b-row class="groupBtn">
          <div class="modal-buttons">
            <img
              class="action-btn"
              width="30"
              height="30"
              src="@/assets/salvar.png"
              :title="$t('salvar')"
              @click="saveMetaValues"
            />
            <img
              class="action-btn ml-2 exit-btn"
              width="30"
              height="30"
              src="@/assets/sair.png"
              :title="$t('cancelar')"
              @click="closeModal"
            />
          </div>
        </b-row>
      </b-card>
    </b-card-body>
  </div>
</template>

<script>
export default {
  name: "TurnoMetaModal",
  props: {
    turno: {
      type: String,
      required: true
    },
    metaItems: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      localMetaItems: []
    };
  },
  created() {
    this.localMetaItems = this.metaItems.map(item => ({
      ...item,
      metaValue: item.metaValue || ""
    }));
  },
  methods: {
    handleNumberInput(value, item) {
      if (value === '' || /^\d*\.?\d*$/.test(value)) {
        item.metaValue = value;
      }
    },
    saveMetaValues() {
      this.$emit('save', this.localMetaItems);
    },
    closeModal() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.modal-title {
  text-align: center;
  margin-bottom: 15px;
  font-size: 18px;
}

.table-container {
  max-height: 400px;
  overflow-y: auto;
  width: 100%;
}

.definir-metas-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.definir-metas-table th,
.definir-metas-table td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: center;
  font-size: 14px;
}

.definir-metas-table th {
  background: #f5f5f5;
}

.manual-input {
  width: 95px;
  padding: 4px;
  border: 1px solid #ccc;
  font-size: 14px;
  outline: none;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.modal-buttons {
  margin-top: 10px;
  text-align: right;
  cursor: pointer;
}

.action-btn {
  border: none;
  background: transparent;
  cursor: pointer;
}

.exit-btn {
  margin-left: 14px;
  margin-right: 14px;
}

.cursor {
  cursor: pointer;
}

.importContainer {
  width: 100%;
  padding: 15px;
}

:deep(.modal-body) {
  padding: 0 !important;
}

:deep(.modal-content) {
  width: 100%;
  max-width: 100%;
}
</style> 